import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {RequestApiService} from "../../../services/domain_code/request-api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../../common.service";
import {QuillEditorComponent} from "ngx-quill";
import {ApiRoutes} from "../../../services/apiroutes";
import {environment} from "../../../../environments/environment";
import {EmptyRepoQuoteModel} from "../quoteTable/lease-quote-table/lease-quote";
import {DocumentModel} from "../../../models/document";
import {LeaseDocuments, LeaseRemarksList} from "../../../models/lease-quote";
import {EmptyRepoQuoteTableService} from "../quoteTable/empty-repo-quote-table/empty-repo-quote-table.service";
import {
    SendEmailConfirmationComponent
} from "../../dialog-box/send-email-confirmation/send-email-confirmation.component";
import {MatDialog} from "@angular/material/dialog";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatSnackBar} from "@angular/material/snack-bar";
import {QuoteEditPayload} from "../quoteTable/base-quote.model";
import {BookingChargesComponent} from "../booking-charges/booking-charges.component";
import {WarningBoxComponent} from "../../dialog-box/warning-box/warning-box.component";
import {RequestServeComponent} from "../request-serve/request-serve.component";

@Component({
    selector: 'logzy-empty-repo-review-quotation',
    templateUrl: './empty-repo-review-quotation.component.html',
    styleUrls: ['./empty-repo-review-quotation.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class EmptyRepoReviewQuotationComponent implements OnInit {

    constructor(public requestService: RequestApiService,
                private route: ActivatedRoute,
                public commonService: CommonService,
                public emptyRepoQuoteService: EmptyRepoQuoteTableService,
                private dialog: MatDialog,
                private router: Router,
                private snackBar: MatSnackBar,
                private requestServeComponent: RequestServeComponent) {
    }

    requestType: string;
    requestId: string;
    type: string = '';
    rtype: string = '';
    @Input() commercials;
    @Input() bookingDetails;
    @Input() bookingCharges;
    @Input() requirementContainers;
    @Input() bookingRequirements;
    quoteObj: EmptyRepoQuoteModel = new EmptyRepoQuoteModel();
    @Input()
    negotiate: boolean = false;
    isEditable: boolean = false;
    emptyRepoDetailsExpand: boolean = true;
    currentDate = new Date();
    fromDays: number;
    toDays: number;
    @ViewChild('editor', {static: false}) editor: QuillEditorComponent;
    baseQuote: any;
    remarks: string;
    disableSaveButton: boolean = false;
    editQuantity: boolean = false;
    editLocation: boolean = false;
    editSizeType: boolean = false;
    @Output()
    closeReview = new EventEmitter();
    @Output()
    backToQuote = new EventEmitter();
    @Input()
    reviewLease;
    @Input()
    reviewing: boolean = false;
    @Input()
    HeaderSet: boolean = true;

    downloadUrl = ApiRoutes.LeadRequest;

    remarksList: LeaseRemarksList[] = [];

    base_url = environment.baseApiUrl;
    location_url = `${ApiRoutes.Location}?location_type_name=port&search=::search::`;
    displayedColumns: string[] = ['original_filename', 'document_size', 'document_type', 'created_by'];

    documentTypeList: LeaseDocuments[] = [];
    selectedDocument: LeaseDocuments = null;
    selectedDocumentType: string = "";
    uploadedDocuments: DocumentModel[] = [];
    showUpload: boolean = false;

    chargeColumns = ['charge_description', 'charge_type', 'quantity', 'total_amount', 'invoice_status'];

    pageLength = 0;
    dropped: boolean = false;
    screenHeight: number;
    screenWidth: number;
    shadowX!: number;
    shadowY!: number;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('title') title: any;
    edit: boolean = false;
    quotePayload = new QuoteEditPayload();
    bookingDetailsExpand: boolean = true;

    @ViewChild(BookingChargesComponent) bookingChargesComponent!: BookingChargesComponent;
    @Output()
    reqContainers = new EventEmitter();

    containerSizeTypeUrl = `${ApiRoutes.ContainerMaster}container_size_type/?search=::search::`

    allErrorsFromApi: string[] = [];

    ngOnInit(): void {
        this.baseQuote = EmptyRepoQuoteModel;

        console.log("reviewEmptyRepo", this.commercials);
        // console.log("this.requestService.selectedRequest?.status?.dev_name", this.requestService.selectedRequest?.status?.dev_name)

        this.commonService.quotationData = this.commercials;

        this.route.queryParams.subscribe(params => {
            if ('id' in params || 'type' in params || 'rtype' in params) {
                this.requestId = params['id'];
                this.type = params['type'];
                this.rtype = params['rtype'];
            }
        });

        if (this.commercials?.uploaded_documents?.length != 0) {
            this.showUpload = true;
        }

        this.getRemarksList();
        this.getDocumentTypeList();
        this.scrolltop();
    }

    pageChanged(event: PageEvent) {
        console.log({event});
    }

    getRemarksList() {
        this.requestService.getRemarksList(this.requestId).subscribe(res => {
            this.remarksList = res.results;
        })
    }

    getDocumentTypeList() {
        this.requestService.getDocumentTypeList('lease_quote').subscribe(res => {
            this.documentTypeList = res.results;
        })
    }

    scrolltop() {
        console.log("on top ")
        console.log("document.querySelector('#top')", document.querySelector("#top"));
        console.log("document.getElementById('top')", document.getElementById("top"));
        setTimeout(() => {
            document.getElementById("top")?.scrollIntoView({block: "start", behavior: "smooth"});
        }, 200);
    }

    errorObj: any = {};

    catchError(error, requirement?) {
        const errorData = {...error.error};

        if (error.status >= 500) {
            this.quoteObj.error = {...error.error};
            this.errorObj = {...error.error};
            return error;
        } else if (error.status > 399 && error.status < 500) {
            if (requirement) {
                this.errorObj = this.errorObj || {};
                this.errorObj[requirement.id] = {
                    ...this.errorObj[requirement.id],
                    ...errorData
                };
            } else {
                this.quoteObj.error = {...error.error};
                this.errorObj = {...error.error};
            }
            return error;
        }
    }

    downloadQuote(quote: EmptyRepoQuoteModel) {
        window.open(this.downloadUrl + 'request_quotes/pdf/empty_repo/' + quote.id + '/', '_blank')
    }

    openSendQuoteConfirmationDialog(quoteId, type, snackBarMessage, mailType): void {
        let htmlContent: string = '';
        this.requestService.getQuoteContentForEmail(quoteId, type, mailType).subscribe(
            (response: string) => {
                htmlContent = response;
                const dialogData = {
                    usersList: [this.requestService.selectedRequest.requestor?.email],
                    userListKey: '',
                    contentURL: ApiRoutes.QuoteConfirmEmailUrl,
                    contentKeys: {
                        to_emails: '',
                        subject: (mailType == 'quote' ? 'Quote is ready for Request No: ' : 'Booking Confirmed for Request No: ') + this.requestService.selectedRequest.request_number,
                        content: htmlContent
                    },
                    mailType: mailType,
                    snackBarMessage: snackBarMessage
                };
                const dialogRef = this.dialog.open(SendEmailConfirmationComponent, {
                    width: '80%', // Set the width of the dialog
                    disableClose: true,
                    data: dialogData
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        console.log('User clicked Yes');
                        this.disableSaveButton = false;
                    } else {
                        this.disableSaveButton = false;
                    }
                    window.location.reload();
                });

                dialogRef.componentInstance.emailSend.subscribe(() => {
                    window.location.reload();
                    // this.closeReview.emit(true);
                });
            },
            (error) => {
                console.error('Error fetching HTML content:', error);
            }
        );
    }

    onMouseMove(e: any) {
        this.dropped = true;
        if (e.clientX < (this.screenWidth / 2)) {//right shadow
            this.shadowX = 5;
        } else if (e.clientX > (this.screenWidth / 2)) {//left shadow
            this.shadowX = -5;
        }
        if (e.clientY > (this.screenHeight / 2)) {//top shadow
            this.shadowY = -4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        } else if (e.clientY < (this.screenHeight / 2)) {//bottom shadow
            this.shadowY = 4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        }
    }

    editQuote(quote: any) {
        quote.edit = true;
        this.edit = true;
    }

    saveQuote(quote: any) {
        this.quotePayload.setEmptyRepoEditPayload(quote);
        // const req = this.bookingDetails.requirements.filter(item => item.requirement == quote.requirement);
        this.requestService.postQuantityAndLocations(quote.id, this.quotePayload.getEmptyRepoQuoteEditPayload()).subscribe({
            next: response => {
                this.snackBar.open('Data Saved Successfully', 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                console.log('postQuotations', response);
                quote.editQuantity = false;
                quote.editPOL = false;
                quote.editPOD = false;
                quote.editContainerSizeType = false;
                this.edit = false;
                this.bookingChargesComponent.ngOnInit();
            },
            error: err => {
                this.extractErrorsFromApi(err.error);
                this.openWarningDialog(this.allErrorsFromApi.toString(), '', 'Ok');
                // this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                //     verticalPosition: 'top',
                //     duration: 5000,
                // });
            }
        });
    }

    showContainers(data: any) {
        this.reqContainers.emit(data);
    }

    extractErrorsFromApi(obj: any) {
        this.allErrorsFromApi = [];
        Object.keys(obj).forEach(key => {
            this.allErrorsFromApi = this.allErrorsFromApi.concat(obj[key]);
        });
    }

    openWarningDialog(label: string, description, action1: string, action2?: string, action3: string = null) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {
                subTitle: label,
                parent: this,
                description: description,
                label1: action1,
                label2: action2,
                label3: action3
            }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
            }
        })
    }

    reset() {
        this.edit = false;
        this.editQuantity = false;
        this.editLocation = false;
        this.editSizeType = false;
        this.requestServeComponent.getBookingDetails(this.requestService.selectedRequest.booking);
    }

    postBookingQuantity(requirement) {
        let payload = {
            quantity: requirement.quantity
        }
        this.requestService.updateBookingQuantity(requirement.id, payload).subscribe({
            next: response => {
                requirement.editQuantity = false
                this.editQuantity = false
                this.snackBar.open("Quantity Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err, requirement);
            }
        })
    }

    postContainerSizeType(requirement) {
        let payload = {
            container_size_type: requirement.container_size_type ? requirement.container_size_type?.id : null
        }
        this.requestService.updateContainerSizeType(requirement.id, payload).subscribe({
            next: response => {
                requirement.editContainerSizeType = false
                this.editSizeType = false
                this.snackBar.open("Sized Type Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err, requirement);
            }
        })
    }

    postBookingLocation(requirement) {
        let payload = {
            pol_list: requirement.pol_list.map(item => item?.id),
            pod_list: requirement.pod_list.map(item => item?.id)
        }
        this.requestService.updateBookingLocation(requirement.id, payload).subscribe({
            next: response => {
                requirement.editPOL = false
                requirement.editPOD = false
                this.editLocation = false;

                this.snackBar.open("Location Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err, requirement);
            }
        })
    }

    saveRequirement(quote) {

        if (quote.editQuantity) {
            this.postBookingQuantity(quote);
        }
        if (quote.editContainerSizeType) {
            this.postContainerSizeType(quote);
        }
        if (quote.editPOL || quote.editPOD) {
            this.postBookingLocation(quote);

        }
    }
}
